module.exports = __webpack_public_path__ + "static/img/aRZ_pic06.05735bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic06.jpg
// module id = +UGb
// module chunks = 5